module.exports = __webpack_public_path__ + "static/318447898_666023138527458_8920156890037171689_n.jpg-1671186393157_256-454fa1892d3bcd00e4a96def22183031.webp";